<template>
    <v-flex class="content-block">
        <div v-infinite-scroll="getContentDirectoryResult"
             :infinite-scroll-distance="2000"
             class="relative-position">
            <status-overlay class="py-5 directory_overlay"
                    :action="initialResultsAction"
                    ></status-overlay>
            <div v-if="contentsList && contentsList.length > 0">
                <v-layout
                        row
                        v-for="(content, index) in contentsList"
                        :key="content.id"
                        class="content-tile"
                        :data-qe-id="`content-directory_result-${index}_open-content-link`"
                        @click="openContent(content)">
                    <v-flex class="content-tile__image">
                        <figure>
                            <img :key="content.contentImageURL"
                                 :src="content.contentImageURL"
                                 :onerror="imageErrorFallback(content.contentFallBackImageURL)"
                            >
                        </figure>
                    </v-flex>
                    <v-flex xs8>
                        <v-layout column wrap>
                            <v-flex class="ypo_cta_blue_color content-tile__title"
                                    :data-qe-id="`content-directory_result-${index}_title`">
                                {{content.title}}
                            </v-flex>
                            <v-flex class="content-tile__type"
                                    :data-qe-id="`content-directory_result-${index}_title-secondary`">
                                {{contentSecondTitle(content)}}
                            </v-flex>
                            <v-flex class="content-tile__mediaType">
                                <v-layout row wrap>
                                    <v-flex v-if="isTypeFilesAndMedia(content)"
                                            :data-qe-id="`content-directory_result-${index}_participant-and-type`">
                                        {{contentDirectoryPageConstant.label.FILES_AND_MEDIA}} |
                                        <span class="content-tile__participant">
                                            {{ content.communityType || ''}} {{contentDirectoryPageConstant.label.PARTICIPANTS_ONLY}}
                                        </span>
                                    </v-flex>
                                    <v-flex v-if="isCommunityPost(content)"
                                            :data-qe-id="`content-directory_result-${index}_home-feed-type`">
                                        {{contentDirectoryPageConstant.label.NEWS_FEED}} |
                                        <span class="content-tile__participant">
                                            {{ content.communityType || ''}} {{contentDirectoryPageConstant.label.PARTICIPANTS_ONLY}}
                                        </span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex class="content-tile__size"
                                    :data-qe-id="`content-directory_result-${index}_file-size`">
                                {{content.fileSize}}
                            </v-flex>
                            <v-flex class="content-tile__date" :data-qe-id="`content-directory_result-${index}_date`">
                                {{getShortDate(new Date(content.date))}}
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout slot="after-container" class="loading-next-status">
                    <status-overlay
                            :action="nextResultsAction"
                            content-height="100px"></status-overlay>
                </v-layout>
            </div>

            <v-layout column v-if="contentsList && contentsList.length === 0"
                      pl-0 pt-3
                      data-qe-id="content-directory_no-result-text`"
                      class="no-result">
                <v-flex v-html="noResultsFoundMessage.labelA" pb-1 class="no-result__label1"></v-flex>
                <v-flex class="no-result__label2">
                    <span v-html="noResultsFoundMessage.labelB"></span>
                    <span v-if="noResultsFoundMessage.labelC">{{noResultsFoundMessage.labelC}}</span>
                    <span class="no-result__directory-link"
                          v-if="noResultsFoundMessage.labelC"
                          data-qe-id="view_full_member_directory_link"
                          @click="loadFullDirectory">
                    {{contentDirectoryPageConstant.label.VIEW_FULL_CONTENT_DIRECTORY}}
                    </span>
                </v-flex>
            </v-layout>
        </div>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import { imageErrorFallback } from "../../../common/utils/utils";
    import {
        contentDirectoryPageConstant,
        buildSearchObjectByParam,
        handleSelectedContent,
    } from '../contentDirectoryPage.constant';
    import { getNoResultStatement } from "../../MemberDirectoryPage/memberDirectoryPage.constants";
    import { getShortDate } from "../../../common/utils/dateTime";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { appConstant } from "../../../app.constant";


    export default {
        name: "ContentSearchResults",
        data() {
            return {
                contentDirectoryPageConstant,
                buildSearchObjectByParam,
            };
        },
        components: {
            StatusOverlay,
        },
        methods: {
            ...mapActions({
                getContentDirectorySearchResults: `contentDirectory/${storeAction.getInitialContentDirectorySearchResults}`,
                getNextContentDirectorySearchResults: `contentDirectory/${storeAction.getNextContentDirectorySearchResults}`,
                getDownloadFolders: `chapter/${storeAction.getDownloadFolders}`,
            }),
            ...mapMutations({
                setContentDirectorySearchText: `contentDirectory/${storeMutation.setContentDirectorySearchText}`,
            }),
            imageErrorFallback,
            getContentDirectoryResult() {
                if (!this.disableContentDirectoryInfiniteScroll) {
                    if (!this.nextContentDirectorySearchOffset) {
                        this.getContentDirectorySearchResults();
                    } else {
                        this.getNextContentDirectorySearchResults();
                    }
                }
            },
            getShortDate,
            loadFullDirectory() {
                this.setContentDirectorySearchText('');
                sessionStorage.removeItem(appConstant.storageKeys.contentDirectoryStoredFilters);
                this.$router.push({
                    path: "/contentDirectoryPage",
                });
            },
            openContent(content) {
                handleSelectedContent(content, this.contentSearchText, this.$router, this.getDownloadFolders, this.isMobileAppBrowser);
            },
            contentSecondTitle(content) {
                let result = content.contentType || '';
                if (content && content.contentType) {
                    if (content.contentType.toLowerCase() === contentDirectoryPageConstant.constant.filesAndMedia.toLowerCase()
                        || content.contentType.toLowerCase() === contentDirectoryPageConstant.constant.post.toLowerCase()) {
                        result = content.communityName || '';
                    }
                }
                return result;
            },
            isTypeFilesAndMedia(content) {
                return content && content.contentType && content.contentType.toLowerCase() === contentDirectoryPageConstant.constant.filesAndMedia.toLowerCase();
            },
            isCommunityPost(content) {
                return content && content.contentType && content.communityType
                    && content.contentType.toLowerCase() === contentDirectoryPageConstant.constant.post.toLowerCase()
                    && content.communityType.toLowerCase() !== contentDirectoryPageConstant.constant.home.toLowerCase();
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                contentDirectoryResults: `contentDirectory/${storeGetters.contentDirectorySearchResults}`,
                contentState: `contentDirectory/${storeGetters.contentState}`,
                contentSearchText: `contentDirectory/${storeGetters.contentDirectorySearchText}`,
                contentSelectedFilters: `contentDirectory/${storeGetters.contentSelectedFilters}`,
                disableContentDirectoryInfiniteScroll: `contentDirectory/${storeGetters.disableContentDirectoryInfiniteScroll}`,
                nextContentDirectorySearchOffset: `contentDirectory/${storeGetters.nextContentDirectorySearchOffset}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            initialResultsAction() {
                return this.actions[storeAction.getInitialContentDirectorySearchResults];
            },
            nextResultsAction() {
                return this.actions[storeAction.getNextContentDirectorySearchResults];
            },

            contentsList() {
                let resultFromAPI = this.contentDirectoryResults && this.contentDirectoryResults.searchResults
                    ? this.contentDirectoryResults.searchResults
                    : [];

                //TODO: temporarily removing Files and Media for Hybrid UI release - until it is mobile ready
                 if (this.isMobileAppBrowser && resultFromAPI.length) {
                     resultFromAPI = resultFromAPI
                         .filter(item => item.contentType &&
                             item.contentType.toLowerCase() !== contentDirectoryPageConstant.constant.filesAndMedia.toLowerCase());
                 }
                return resultFromAPI;
            },
            noResultsFoundMessage() {
                return getNoResultStatement(this.contentSearchText, (this.contentSelectedFilters || []), this.$route.name);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .content-tile {
        font-family: 'Noto Sans', sans-serif !important;
        padding: 20px 5px 5px 15px;
        transition: 0.3s all ease;
        height: 176px;
        border-bottom: 1px solid rgba($ypo-gray, 0.5);
        position: relative;
        cursor: pointer;

        &:hover {
            background: rgba($ypo-cta, 0.09);
        }

        .flex {
            flex: 0 1 auto !important;
        }

        &__title {
            font-weight: bold;
            color: $ypo_blue;
            text-overflow: ellipsis;
            font-size: 18px;
            white-space: nowrap;
            overflow: hidden;

            &:hover {
                text-overflow: clip;
                white-space: normal;
                text-align: left;
            }

            a {
                text-decoration: none;
                color: $ypo-cta;
            }

            @include breakpoint(xs) {
                font-size: 16px;
            }
        }

        &__image {
            padding-right: 40px;

            @include breakpoint(sm) {
                padding-right: 20px;
            }

            figure {
                height: 120px;
                width: 120px;
                overflow: hidden;

                img {
                    max-width: 100%;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }

        &__type {
            color: $ypo_blue;
            font-size: 14px;
            margin-top: -3px;
        }

        &__mediaType {
            color: $ypo-black-opac;
            font-size: 14px;
            margin-top: 15px;
            min-height: 24px;

            @include breakpoint(xs) {
                margin-top: 10px;
            }

        }

        &__participant {
            color: $ypo_gold;
            font-size: 14px;
        }

        &__size {
            color: $black;
            font-size: 14px;
            min-height: 21px;
            letter-spacing: 0.08px;
        }

        &__date {
            color: $black;
            margin-top: 10px;
            font-size: 14px;
            letter-spacing: 0.08px;

            @include breakpoint(xs) {
                margin-top: 5px;
            }
        }

        @include breakpoint(xs) {
            border: 1px solid rgba($ypo-gray, 0.5);
            margin: 3px 10px;
            min-height: 170px;
            border-radius: 3px;
            h2 {
                font-size: 18px;
            }
            &__type, &__size {
                font-size: 14px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
            &__image {
                left: 7px;

                figure {
                    height: 80px;
                    width: 80px;
                }
            }
        }
    }

    .loading-next-status {
        position: relative;
        min-height: 100px;
    }

    .no-result {
        font-family: 'Noto Sans', sans-serif;

        &__label1 {
            font-size: 18px;
            font-weight: 600;
        }

        &__label2 {
            font-size: 15px;
        }

        &__directory-link {
            color: $ypo-cta;
            font-weight: 600;
            cursor: pointer;
        }
    }

</style>

